module.exports = __webpack_public_path__ + "img/service-swiper-8-pic.247bdb80.png";